import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

import WelcomeSlider from '../WelcomeSlider';
import Navigation from '../Navigation';
import LandingPage1 from '../LandingPage1';
import LandingPage2 from '../LandingPage2';
import LandingPage3 from '../LandingPage3';
import LandingPage4 from '../LandingPage4';
import SignUpPage from '../SignUp';
import SignInPage from '../SignIn';
import PasswordForgetPage from '../PasswordForget';
import HomePage from '../Home';
import AccountPage from '../Account';
import HactivateContainer from '../HactivateContainer';
import withAuthentication from '../Session/withAuthentication';

import Gigs from '../Gigs';
import GigDetail from '../GigDetail';

import Courses from '../Courses';

import Certificate from '../Certificate';


import * as routes from '../../constants/routes';

import welcomeImg1 from './welcome-1-bg.jpg';
import welcomeImg2 from './welcome-2-bg.jpg';
import welcomeImg3 from './welcome-3-bg.jpg';
import signupBgImg from './signup-bg.jpg';

import hactivateData from '../../data/hactivate.json';

import './index.css';

const backgroundImageFromFirebase = 'https://firebasestorage.googleapis.com/v0/b/hactivate-v1.appspot.com/o/background.jpg?alt=media&token=99441207-f25e-48fa-99d0-11ee8accc50e';

const styles = {
  background: `url(${backgroundImageFromFirebase})`,
  minHeight: `100vh`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  padding: '1em'
}

const App = () =>
  <Router>
    <div style={styles}>
      <div className="app">
        <Navigation />

        <Route exact path={routes.LANDING} component={ () =>
          <WelcomeSlider>
            <LandingPage1 bgImg={welcomeImg1} />
            <LandingPage2 bgImg={welcomeImg2} />
            <LandingPage3 bgImg={welcomeImg3} />
            <LandingPage4 bgImg={signupBgImg} >
              <SignUpPage />
            </LandingPage4>
          </WelcomeSlider>
        } />

        <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
        <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
        <Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
        <Route exact path={routes.HOME} component={() => <HomePage />} />
        <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />


        <Route exact path={routes.COURSES} component={ () =>

            <HactivateContainer
              bgColor="#DBFD0C"
            >
            <Courses courses={hactivateData.courses} />
            </HactivateContainer>
        } />

        <Route exact path={routes.GIGDETAIL} component={GigDetail}/>
        <Route exact path={routes.GIGS} component={ () =>

          <HactivateContainer
            bgColor="#3CB7D7"
          >
            <Gigs gigs={hactivateData.gigs} />
          </HactivateContainer>
        } />

        <Route exact path={routes.CERTIFICATE} component={Certificate}/>

      </div>
    </div>
  </Router>

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/components/App/index.js